import { createWebappRoute } from '@/router/helpers';

export default [
  // "emp/:id": "showEmp",
  createWebappRoute({
    path: '/emp/:id',
    name: 'emp-id-module',
    component() {
      console.log('ROUTER, emp/:id');

      $dtteam.viewEmployee.call($dtteam, id);

      return {};
    },
  }),
];
